// Stacking order on a dashboard page, bottom to top: the corner feedback
// launcher (900), the Questions panel, popups the panel portals to the page
// root, then antd popups (1000 and up). The DashAI Radix popover portals to the
// page root at z-50, so a popover opened from the panel takes PANEL_POPUP_LAYER
// or it opens behind the panel. Tooltips render in place inside the panel and
// need no layer.

/** Above the feedback launcher, so it never covers the panel's input. */
export const PANEL_LAYER = "z-[950]";

/** Popovers the panel opens through a portal, such as the thumbs feedback box. */
export const PANEL_POPUP_LAYER = "z-[960]";
